import { render, staticRenderFns } from "./VerticalNavMenuSectionTitle.vue?vue&type=template&id=a78357ea&scoped=true"
import script from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuSectionTitle.vue?vue&type=style&index=0&id=a78357ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78357ea",
  null
  
)

export default component.exports